import { getLanguages as getLanguagesAction, languageApiResponseSuccess, languageApiResponseError } from './action';
import { GET_LANGUAGES } from './actionType';
import config from '../../config';

export const getLanguages = () => async (dispatch) => {
    try {
        dispatch(getLanguagesAction());
        const authUser = JSON.parse(sessionStorage.getItem("authUser"));
        
        const response = await fetch(`${config.api.API_URL}language/?status=1`, {
            headers: {
                'Authorization': authUser?.token || '',
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        const languagesArray = data.result || [];
        dispatch(languageApiResponseSuccess(GET_LANGUAGES, languagesArray));
    } catch (error) {
        dispatch(languageApiResponseError(GET_LANGUAGES, {
            message: error.message || 'An error occurred while fetching languages'
        }));
    }
}; 